import env from '@beam-australia/react-env';

export const loadConfig = () => {
  const apiBaseUrl = env('API_BASE_URL') || '';
  const authBaseUrl = env('OAUTH_BASE_URL') || '';
  const oAuth2ClientId = env('OAUTH_CLIENT_ID') || '';
  const oAuth2RedirectUri = env('OAUTH_REDIRECT_URI') || '';

  return {
    apiBaseUrl,
    authBaseUrl,
    oAuth2ClientId,
    oAuth2RedirectUri
  };
};
